import { chain, SetCartStatus } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetCartNotes = createChainHandler("SetCartNotes", chain, props => {
    const { editedCartNotes } = props.getState().pages.checkoutShipping;

    if (props.cartToUpdate && typeof editedCartNotes !== "undefined") {
        props.cartToUpdate.notes = editedCartNotes ?? "";
    }
});
addToChainAfter(chain, SetCartStatus, SetCartNotes);
